module.exports = __webpack_public_path__ + "static/img/gpt11.978c26d1.jpg";